import { render, staticRenderFns } from "./PaymentsHistory.vue?vue&type=template&id=6d609a23"
import script from "./PaymentsHistory.vue?vue&type=script&lang=js"
export * from "./PaymentsHistory.vue?vue&type=script&lang=js"
import style0 from "./PaymentsHistory.vue?vue&type=style&index=0&id=6d609a23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports